import type { Recipe } from '../../build-config';
import { isSignature } from '../helpers/elevations';
import { planLayer, styleLayer } from '../helpers/layers';

export const signatureRecipe = (state?: Recipe['state']): Recipe => ({
  layers: [planLayer, styleLayer],
  where: isSignature,
  state
});
